import { render, staticRenderFns } from "./DataPeriod.vue?vue&type=template&id=3adaeaa7"
import script from "./DataPeriod.vue?vue&type=script&lang=js"
export * from "./DataPeriod.vue?vue&type=script&lang=js"
import style0 from "./DataPeriod.vue?vue&type=style&index=0&id=3adaeaa7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports